import axios from '../../http_v2'
export default {
    add: (data) => {
        return axios.post('activityservice/conncilhousemanage/save', data)
    },
    update: (data) => {
        return axios.post('activityservice/conncilhousemanage/update', data)
    },
    del: (data) => {
        return axios.post('activityservice/conncilhousemanage/remove', data)
    },
    list: (params) => {
        return axios.get('activityservice/conncilhousemanage/list', params)
    },
}
